export default "__VITE_ASSET__C$RMXyAX__"